import { Link } from "react-router";

export function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-foreground mb-2">
          Page not found
        </h1>
        <p className="text-muted-foreground mb-6">
          That page doesn't exist in the data room.
        </p>
        <Link to="/" className="text-primary hover:text-primary-hover underline">
          Back to overview
        </Link>
      </div>
    </div>
  );
}
